export const SERVICE_STATUS_TYPES = [
  { CODE: 0, TEXT: '草稿中' },
  { CODE: 1, TEXT: '已发布' },
  { CODE: 2, TEXT: '已下架' },
]
export const SERVICE_AUDIT_TYPE = [
  { CODE: 0, TEXT: '草稿中' },
  { CODE: 3, TEXT: '审核中' },
  { CODE: 4, TEXT: '通过审核' },
  { CODE: 5, TEXT: '未通过审核' },
]
export const SERVICE_AUDIT_TYPES = {
  DRAFT: { CODE: 0 },
  APPROVED: { CODE: 4 },
  AUDITING: { CODE: 3 },
  REJECTED: { CODE: 5 },
}
export const CONSULTING_AUDIT_TYPE = [
  { CODE: 0, TEXT: '审核中' },
  { CODE: 2, TEXT: '已拒绝' },
]

export const CONSULTING_AUDIT_TYPES = {
  AUDITING: { CODE: 0 },
  APPROVED: { CODE: 1 },
  REJECTED: { CODE: 2 },
}

export const COURSE_TYPES = [
  { CODE: 2, TEXT: '在线实战项目', AUDIT_COURSE_PATH: 'getAuditingOnlineAction' },
  { CODE: 3, TEXT: '名企一对一', AUDIT_COURSE_PATH: 'getAuditingEnterpriseToOne' },
  { CODE: 4, TEXT: '求职辅导', AUDIT_COURSE_PATH: 'getAuditingJobCounseling' },
]

export const COURSE_TYPE = {
  ONLINE_ACTION: { CODE: 2 },
  ENTERPRISE_TO_ONE: { CODE: 3 },
  JOB_COUNSELING: { CODE: 4 },
}
export const APPLIED_SERVICE_TYPES = [
  { CODE: 7, TEXT: '篱笆预告(拼班)', COURSE_PATH: 'updateLibaPreview' },
  { CODE: 2, TEXT: '在线实战项目', COURSE_PATH: 'updateOnlineAction' },
  { CODE: 3, TEXT: '名企一对一', COURSE_PATH: 'updateEnterpriseToOne' },
  { CODE: 4, TEXT: '求职辅导', COURSE_PATH: 'updateJobCounseling' },
  { CODE: 8, TEXT: '讲座/分享会', COURSE_PATH: 'updateLecture' },
]
export const APPLIED_SERVICE_TYPE = {
  LIBA_PREVIEW: { CODE: 7 },
  ONLINE_ACTION: { CODE: 2 },
  ENTERPRISE_TO_ONE: { CODE: 3 },
  JOB_COUNSELING: { CODE: 4 },
  LECTURE: { CODE: 8 },
}

export const USER_APPLICATION_STATUS_TYPES = [
  { CODE: 0, TEXT: '已报名' },
  { CODE: 1, TEXT: '已交钱' },
  { CODE: 2, TEXT: '已完结' },
  { CODE: 3, TEXT: '已取消' },
]

export const OFFERED_SERVICE_TYPES = [
  { CODE: 1, TEXT: '免费公开课', COURSE_PATH: 'updateFreeOpenCourse' },
  { CODE: 2, TEXT: '在线实战项目', COURSE_PATH: 'updateOnlineAction' },
  { CODE: 3, TEXT: '名企一对一', COURSE_PATH: 'updateEnterpriseToOne' },
  { CODE: 4, TEXT: '求职辅导', COURSE_PATH: 'updateJobCounseling' },
  { CODE: 8, TEXT: '讲座/分享会', COURSE_PATH: 'updateLecture' },
]

export const TAG_TYPES = [
  { CODE: 1, TEXT: '课程标签' },
  /*   { CODE: 2, TEXT: '内推标签' },   */
  { CODE: 3, TEXT: '导师擅长领域标签' },
  { CODE: 4, TEXT: '导师所处行业标签' },
/*   { CODE: 5, TEXT: '干货面经标签' }, */
]
export const TAG_TYPE = {
  COURSE_TAG: { CODE: 1, TEXT: '课程标签' },
  REFERRAL_TAG: { CODE: 2, TEXT: '内推标签' },
  EXPERT_FIELD_TAG: { CODE: 3, TEXT: '导师擅长领域标签' },
  INDUSTRY_TAG: { CODE: 4, TEXT: '导师所处行业标签' },
  /* INTERVIEW_TAG: { CODE: 5, TEXT: '干货面经' }, */
}

export const MENTOR_APPLICATION_STATUS = [
  { CODE: 0, TEXT: '未处理' },
  { CODE: 1, TEXT: '已通过' },
  { CODE: 2, TEXT: '已拒绝' },
]

export const USER_TYPES = [
  { CODE: 2, TEXT: '导师', MODIFY: false },
  { CODE: 3, TEXT: '嘉宾', MODIFY: true },
  { CODE: 4, TEXT: '普通用户', MODIFY: true },
]

export const LIBA_PREVIEW_COURSE_TYPES = [
  { CODE: 2, TEXT: '在线实战项目' },
  { CODE: 4, TEXT: '求职辅导' },
  { CODE: 8, TEXT: '讲座/分享会' },
]
export const LIBA_PREVIEW_COURSE_TYPE = {
  ONLINE_ACTION: { CODE: 2 },
  JOB_COUNSELING: { CODE: 4 },
  LECTURE: { CODE: 8 },
}

export const ACCOUNT_TYPE = {
  PHONE: { CODE: 1, TEXT: '手机号' },
  EMAIL: { CODE: 2, TEXT: '邮箱' },
  WECHAT: { CODE: 3, TEXT: '微信' },
  UNKNOWN: { CODE: 4, TEXT: 'Google' },
}
export const ACCOUNT_TYPES = [
  { CODE: 1, TEXT: '手机号' },
  { CODE: 2, TEXT: '邮箱' },
  { CODE: 3, TEXT: '微信' },
  { CODE: 4, TEXT: 'Google' },
]

export const INTERVIEW_TAG_TYPES = [
  { CODE: 6, TEXT: '职位类型标签' },
  { CODE: 7, TEXT: '题目类型标签' },
]

export const INTERVIEW_TAG_TYPE = {
  QUESTION_TAG: { CODE: 7, TEXT: '题目类型标签' },
  POSITION_TAG: { CODE: 6, TEXT: '职位类型标签' },
}
export const STATUS_OPTIONS = [
  { CODE: 0, TEXT: '草稿中' },
  { CODE: 1, TEXT: '已发布' },
  { CODE: 2, TEXT: '已下架' },
]

export const HAS_REFERRAL = [
  { CODE: 0, TEXT: '没有内推' },
  { CODE: 1, TEXT: '有内推' },
]

export const DATASOURCE = [
  { CODE: 0, TEXT: '后台添加' },
  { CODE: 1, TEXT: '爬虫添加' },
]

export const EVENT_TYPES = [
  { CODE: 0, TEXT: '系统' },
  { CODE: 1, TEXT: '拉新' },
  { CODE: 2, TEXT: '签到' },
  { CODE: 3, TEXT: '练习题' },
]
export const OP_TYPES = [
  { CODE: 1, TEXT: '增加' },
  { CODE: 2, TEXT: '消耗' },
]
export const VM_TYPES = [
  { CODE: 1, TEXT: '积分' },
]
export const CAREER_MONITOR_STATUS_TYPES = [
  { CODE: 0, TEXT: '暂无更新岗位' },
  { CODE: 1, TEXT: '成功' },
  { CODE: 2, TEXT: '失败' },
]
